<template>
  <div class="about-story">
    <div class="about-story__wrapper" :class="`${block.settings.story_section_csslass}`">
      <div class="about-story__inner-body">
        <div class="about-story__headline-1"><h5>{{block.settings.story_headline}}</h5></div>
        <div class="about-story__headline-2"><p v-html="block.settings.story_paragraph"></p></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutStory',
  props: {
    block: Object
  }
}
</script>
<style lang="scss">
  .about-story {
    height: 500px;
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 70px;

    @include tablet-up {
      height: 500px; 
    }
    @include mobile-only {
      display: flex;
      padding-left: 43px ;
      padding-right: 43px;
      margin-bottom: 175px;
    }

    .banner_bottom { 
      margin-top: 100px;
    
      @include mobile_only {
        margin-top: 200px;
      } 
    }

    .story_after_fifty {

      @include mobile_only {
        margin-top: 50px;
      } 
    }

    &__wrapper {
      margin: 0 auto;
      height: 100%;
      max-width: 1441px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @include tablet-up {
        max-width: 710px;
      }
    }

    &__headline-1 h5 {
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 4.5px;
      font-family: $font-family-primary;
      color: $color-terracotta-200;
      text-transform: uppercase;
      margin-bottom: 20px;

      @include mobile_only {
        text-align: left;
        font-size: 14px;
        line-height: 20px;
      }
    }

    &__headline-2 p {
      font-size: 18px;
      line-height: 30px;
      font-family: $font-family-primary;
      color: $color-black-900;

      @include mobile_only {
        text-align: left;
        font-size: 15px;
        line-height: 25px;
      }

    }
    
    &__inner-body {
      position: relative;
      margin: 0 auto;
      text-align: center;
    }
  }
</style>